import { render, staticRenderFns } from "./VueEmail.vue?vue&type=template&id=b50aaaee&scoped=true"
import script from "./VueEmail.vue?vue&type=script&lang=js"
export * from "./VueEmail.vue?vue&type=script&lang=js"
import style0 from "./VueEmail.vue?vue&type=style&index=0&id=b50aaaee&prod&lang=scss&scoped=true"
import style1 from "./VueEmail.vue?vue&type=style&index=1&id=b50aaaee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50aaaee",
  null
  
)

export default component.exports